import React, { Component, PropTypes } from 'react';
import { Units, Colors } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    margin: 2,
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'flex-start',
    borderColor: Colors.material.grey[300].hex,
    backgroundColor: Colors.theme.Light.card,
    '&transparent': {
      backgroundColor: 'transparent',
      border: 'none',
      margin: `0 ${Units.base / 2}px`
    },
    '&right': {
      marginLeft: 'auto'
    },
    '&fullWidth': {
      flexGrow: 1,
      flexShrink: 0
    }
  }
});

class ToolbarGroup extends Component {
  static propTypes = {
    children: PropTypes.node,
    right: PropTypes.bool,
    transparent: PropTypes.bool,
    fullWidth: PropTypes.bool
  };

  render() {
    const { children, right, fullWidth, transparent, ...other } = this.props;
    const classes = classNames(css.root, {
      [css.right]: right,
      [css.transparent]: transparent,
      [css.fullWidth]: fullWidth
    });
    return (
      <div className={classes} {...other}>
        {children}
      </div>
    );
  }
}

export default ToolbarGroup;



// WEBPACK FOOTER //
// ./src/js/components/Toolbar/ToolbarGroup.js